import styled from 'styled-components'

interface ICardPinModalStyledProps {}

export const CardPinModalStyled = styled.div<ICardPinModalStyledProps>`
  iframe {
    width: 100%;
    height: ${(props) => props.theme.typography.pxToRem(30)};
  }
`
